import { createContext, Dispatch, SetStateAction } from "react"
import { Graph, Link } from '../components/sankey/diagram/diagram.ts'
import { MoneyFlowMongo, SankeyData } from "../backend/types/moneyflow.ts"
import { Document } from "../backend/types/document.ts"
import { DiagramMode } from '../types/diagram.ts'
import { TransactionTableTabs } from "../components/TransactionTable/transactionTable.tsx"

type ElementProps = Record<string, Record<string, string | number>>
type TransactionTableType = {
    activeTabKey: TransactionTableTabs,
    onChangeTab: (activeKey: TransactionTableTabs) => void
}

export const MoneyFlowContext = createContext({
    moneyFlow: {} as unknown as Document<MoneyFlowMongo> | undefined,
    graph: [] as unknown as Graph,
    nodesProps: {} as unknown as ElementProps,
    linkProps: {} as unknown as ElementProps,
    sankeyData: {} as SankeyData | undefined,
    mode: 'original' as DiagramMode,
    threshold: 0,
    moneyFlowID: '',
    transactionTable: {
        activeTabKey: TransactionTableTabs.ALL,
        onChangeTab: () => { }
    } as TransactionTableType
})

export const CustomizeMoneyFlowContext = createContext({
    setLinkProps: (() => { }) as Dispatch<SetStateAction<ElementProps>>,
    setNodesProps: (() => { }) as Dispatch<SetStateAction<ElementProps>>,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    highlightNode: (nodeId: string, endNodeId: string = 'origin') => { },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    highlightNodeByOriginalId: (nodeId: string, endNodeId: string = 'origin') => { },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    highlightLinkByAddresses: (senderAddress: string, receiverAddress: string) => { },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    highlightLink: (link: Link) => { },
    removeEffects: () => { },
    switchMode: () => { },
    setThreshold: (() => { }) as Dispatch<SetStateAction<number>>,
})
